module.exports = __webpack_public_path__ + "img/MyTicket.159450b5.png";